const BASE = process.env.REACT_APP_BASE_URL as string;

export const API = {
  // Auth
  LOGIN: `${BASE}/v1/auth/login`,

  // Accounting
  TRX_PAID: `${BASE}/v1/accounting/transaction-paid`,
  TRX_SALE: `${BASE}/v1/accounting/transaction-sale`,
  UPLOAD_BANK_LOG: `${BASE}/v1/accounting/upload-bank-log`,
  EXPORT_SALE: `${BASE}/v1/export/transaction-sale`,

  // Purchase Order
  PURCHASE_ORDER: `${BASE}/v1/dc/po`,
  PURCHASE_ORDER_OPEN: `${BASE}/v1/dc/po/list/open`,
  PURCHASE_ORDER_EXPORT: `${BASE}/v1/export/pdf/po`,

  // PYRQ
  PYRQ: `${BASE}/v1/dc/pyrq`,
  PYRQ_EXPORT: `${BASE}/v1/export/pdf/pyrq`,

  // BPK
  BPK: `${BASE}/v1/dc/bpk`,
  BPK_EXPORT: `${BASE}/v1/export/pdf/bpk`,
  BPK_BY_PYRQ_EXPORT: `${BASE}/v1/export/pdf/bpk-by-pyrq`,

  // Product & Catalog
  PRODUCT: `${BASE}/v1/product`,
  PRODUCT_LIST: `${BASE}/v1/product-list`,
  PRODUCT_SEARCH: `${BASE}/v1/product-search`,
  TYPE: `${BASE}/v1/type`,

  // Supplier
  SUPPLIER: `${BASE}/v1/dc/supplier`,
  SUPPLIER_LIST: `${BASE}/v1/dc/supplier-list`,

  // Stock
  INPUT_STOCK: `${BASE}/v1/gudang/input-stock`,
  STOCK_ADJUSTMENT: `${BASE}/v1/admin/stock-adjustment`,
  STOCK_TRANSFER: `${BASE}/v1/admin/stock-transfer`,

  // Others
  BRANCH: `${BASE}/v1/branch`,
  TENANT_SHOP: `${BASE}/v1/tenant/shop`,

  // Disabled features (kept for reference)
  HISTORY_WEEK_SALE: `${BASE}/v1/dc/history-week-sale`,
  HISTORY_PROJECTION: `${BASE}/v1/dc/projection`,
  HISTORY_WEEK_TO_ORDER: `${BASE}/v1/dc/week-to-order`,
};
